<template>
  <div v-if="productData && Object.keys(cartProduct).length !== 0" class="col-12 advCartRow">
    <div class="advCartGiftRowContainer row minicart-item-row">
      <div class="advCartGiftRowImage col-2 minicart-item-thumb">
        <div class="thumbnail_container">
          <div class="thumbnail">
            <img :src="imageSrc" :alt="productData.productName"/>
          </div>
        </div>
      </div>
      <div class="advCartGiftRowInfo col-10 col-sm-4 col-5 col-md-4 minicart-item-title text-left">
        <div class="row row-mlr-0 no-gutters">
          <div class="col-12 m-auto gift-row-badge text-left">
            <span class="gift-badge">
              {{ t('gift') }}
              <span v-if="cartProduct.quantity">
                  <i class="ti-close"></i> {{ cartProduct.quantity }}
              </span>!
            </span>
          </div>
          <div class="col-12 m-auto gift-row-name text-left">
            {{ productData.productName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import giftSelectionMixin from './mixins/giftSelectionMixin'
import cartGiftOptionsMixin from './mixins/cartGiftOptionsMixin'

export default {
  name: 'AdvCartGiftRowV2',
  mixins: [giftSelectionMixin, cartGiftOptionsMixin],
  props: {
    cartProduct: {
      type: Object
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    productData () {
      return store.getters.getProductById(this.cartProduct.productId)
    },
    imageSrc () {
      return this.productData.hasOwnProperty('productImage') ? this.productData.productImage.list : store.getters.noImage
    }
  }
}
</script>

<style lang="scss" scoped>
.advCartGiftRowContainer {

}
</style>
